import { Container, Row } from "reactstrap";
import { Breadcrumbs } from "../../../AbstractElements";
import { ModalTitle, UiKits } from "../../../Constants/Constants";
import BasicModal from "./BasicModal";
import SizeModal from "./SizeModal";
import FullscreenModal from "./FullscreenModal";
import CenteredModal from "./CenteredModal";
import ToggleModal from "./ToggleModal";
import StaticModal from "./StaticModal";
import CustomModals from "./CustomModals";

const ModalContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={ModalTitle} parent={UiKits} />
      <Container fluid>
        <Row>
          <BasicModal />
          <SizeModal />
          <FullscreenModal />
          <CenteredModal />
          <ToggleModal />
          <StaticModal />
          <CustomModals />
        </Row>
      </Container>
    </>
  );
};
export default ModalContainer;
